var path = '/app/components/ui/status-bar/status-bar.html';
var html = "<div class=status-bar-container> <div class=\"status-bar-item lifes\"> <div class=capituled>{{$ctrl.lifes}}/{{$ctrl.totals.lifes}}</div> </div> <div class=\"status-bar-item stars\"> <div class=capituled>{{$ctrl.getTotalCollected()}}/{{$ctrl.totals.stars}}</div> </div> <div class=\"status-bar-item chef\"> <div class=capituled>{{$ctrl.getChefTotalCollected()}}/{{$ctrl.totals.chef}}</div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/status-bar/status-bar.html
// module id = 237
// module chunks = 0